module.exports = __webpack_public_path__ + "static/media/thedistillery.40d18a79.jpg";